import { Injectable } from '@angular/core';
import { EnvConfigurationService } from './envconf.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { Fleet } from '../models/fleet/fleet';
import { TruckSpec } from '../models/tire/TruckSpec';

@Injectable({
  providedIn: 'root'
})
export class FleetService {
  endpoint: string = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/fleet`;

  /**
   * Constructor
   *
   * @param http httpClient
   *  @param apiService apiService
   */
  constructor(private readonly http: HttpClient, private readonly apiService: ApiService) {}

  /**
   * Get fleet quantities
   */
  getFleetQuantities(siteId: number, fromYear: number, fromMonth: number): Observable<Array<Fleet>> {
    return this.http.get<Array<Fleet>>(`${this.endpoint}?siteId=${siteId}&fromYear=${fromYear}&fromMonth=${fromMonth}`);
  }

  /**
   * Persist all modifications done on fleets (modifications, additions, deletions)
   */
  saveFleets(siteId: number, fromYear: number, fromMonth: number, toDelete: number[], data: Fleet[]) {
    return this.http.put(
      `${this.endpoint}?siteId=${siteId}&fromYear=${fromYear}&fromMonth=${fromMonth}&toDelete=${toDelete}`,
      data.map((fleetQty) => {
        return {
          truckStatFk: fleetQty.truckStat.truckStatPk,
          truckSpecFk: fleetQty.truckSpec.truckSpecPk,
          fcsts: fleetQty.fcsts
        };
      })
    );
  }

  /**
   * Get all truck specifications
   */
  getAllTruckSpecs() {
    return this.http.get<TruckSpec[]>(`${this.endpoint}/truck-specs`);
  }

  generateFleets(siteId: number, fromYear: number, fromMonth: number, selection: TruckSpec[]): Observable<Array<Fleet>> {
    return this.http.post<Array<Fleet>>(
      `${this.endpoint}/generate-fleets?siteId=${siteId}&fromYear=${fromYear}&fromMonth=${fromMonth}`,
      selection
    );
  }

  /**
   * Recalculate forecast for a given site
   * @param siteId
   */
  recalculateForecast(siteId: number) {
    return this.http.post(`${this.endpoint}/recalculate-forecast`, { siteId });
  }
}
